import { religiousbodyList, sortList } from '../../../DefaultData';
import type { RecruitBoardConfig } from './RecruitTypes';
import { OVERSEAS_REGIONS } from '../recruit_overseas/overseasData';

const CHURCH_JOB_SORTS = ['찬양대', '방송', '직원'];

export const MINISTER_RECRUIT_CONFIG: RecruitBoardConfig = {
  boardTitle: '국내사역지 구인',
  apiBase: 'recruitminister',
  listPath: '/recruit',
  postPath: '/recruit/recruitministerpost',
  detailPath: '/recruit/minister',
  filterTabs: ['직무', '직분', '지역', '사례비', '교단'],
  sortOptions: sortList,
  sortFilterField: 'sort',
  showPayInList: true,
  showSortInListEtc: true,
  etcColumnLabel: '사역조건/지역',
  showMinistryDetail: true,
  churchLogoImagePath: 'images/recruit/churchlogo',
  religiousbodyDetailImagePath: 'siteimages/religiousbody',
  tableType: 'minister',
  canApply: true,
};

export const OVERSEAS_RECRUIT_CONFIG: RecruitBoardConfig = {
  boardTitle: '해외사역지 구인',
  apiBase: 'recruitoverseas',
  listPath: '/recruit/recruitoverseaslist',
  postPath: '/recruit/recruitoverseaspost',
  detailPath: '/recruit/overseas',
  filterTabs: ['직무', '직분', '지역', '사례비', '교단'],
  sortOptions: sortList,
  sortFilterField: 'sort',
  showPayInList: true,
  showSortInListEtc: true,
  etcColumnLabel: '사역조건/지역',
  showMinistryDetail: true,
  churchLogoImagePath: 'images/recruit/churchlogo',
  religiousbodyDetailImagePath: 'siteimages/religiousbody',
  tableType: 'overseas',
  locationOptions: OVERSEAS_REGIONS,
  mapProvider: 'google',
  canApply: true,
};

export const CHURCH_RECRUIT_CONFIG: RecruitBoardConfig = {
  boardTitle: '찬양대/방송/직원 구인',
  apiBase: 'recruitchurch',
  listPath: '/recruit/recruitchurchlist',
  postPath: '/recruit/recruitchurchpost',
  detailPath: '/recruit/church',
  filterTabs: ['직무', '지역'],
  sortOptions: CHURCH_JOB_SORTS,
  sortFilterField: 'title',
  showPayInList: false,
  showSortInListEtc: false,
  etcColumnLabel: '지역',
  showMinistryDetail: false,
  churchLogoImagePath: 'images/recruit/churchlogo',
  religiousbodyDetailImagePath: 'images/recruit/religiousbody',
  simplePostType: 'church',
};

export const INSTITUTE_RECRUIT_CONFIG: RecruitBoardConfig = {
  boardTitle: '학교/기관/단체 구인',
  apiBase: 'recruitinstitute',
  listPath: '/recruit/recruitinstitutelist',
  postPath: '/recruit/recruitinstitutepost',
  detailPath: '/recruit/institute',
  filterTabs: ['지역'],
  sortFilterField: 'title',
  showPayInList: false,
  showSortInListEtc: false,
  etcColumnLabel: '지역',
  showMinistryDetail: false,
  churchLogoImagePath: 'images/recruit/churchlogo',
  religiousbodyDetailImagePath: 'images/recruit/religiousbody',
  simplePostType: 'institute',
};

/** 교단 필터 탭 옵션 */
export const RECRUIT_RELIGIOUSBODY_OPTIONS = religiousbodyList;
